import React from 'react';

const InfoPanel = () => {
  return (
    <div>Info Panel</div>
  )
}

export default InfoPanel;